import { useState } from 'react';
import { Range } from 'components/Range/Range';
import { useAppStore } from '../../store/store';
import s from './RangeForm.module.css';

export const RangeForm = () => {
  const [valueRangeStorage, setValueRangeStorage] = useState(0);
  const [valueRangeTransfer, setValueRangeTransfer] = useState(0);
  const { setStorageRange, setTransferRange } = useAppStore();
  const onChangeRangeStorage = e => {
    setValueRangeStorage(parseInt(e.target.value));
    setStorageRange(parseInt(e.target.value));
  };
  const onChangeRangeTransfer = e => {
    setValueRangeTransfer(parseInt(e.target.value));
    setTransferRange(parseInt(e.target.value));
  };

  return (
    <div className={s.rangeForm}>
      <Range
        label={'Storage: '}
        onChange={onChangeRangeStorage}
        value={valueRangeStorage}
      />
      <Range
        label={'Transfer: '}
        onChange={onChangeRangeTransfer}
        value={valueRangeTransfer}
      />
    </div>
  );
};
